import { render, staticRenderFns } from "./filterBDI.vue?vue&type=template&id=600b69fd&scoped=true"
import script from "./filterBDI.vue?vue&type=script&lang=js"
export * from "./filterBDI.vue?vue&type=script&lang=js"
import style0 from "./filterBDI.vue?vue&type=style&index=0&id=600b69fd&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "600b69fd",
  null
  
)

export default component.exports